// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1kH2R","options":"AnswerScale_options__22Cen","selected":"AnswerScale_selected__24_eO"};